export interface EntityPropertyDisplayConfiguration {
  id?: string;
  propertyName?: string;
  entityPropertyId?: string;
  type?: number;
  columnName: string;
  subColumnName?: string;
  orderColumn?: number;
  option: string;
  orderRow?: number;
  sortType?: number;
  columnNameDescription?: string;
  order?: number;
  optionName?: string;
  deleted?: boolean;
  isUsed?: boolean;
  isEnable?: boolean;
  columnNameMaxLength?: number;
  entityNameRef?: string;
  entityReferencePropertyId?: string;
  entityReferenceLinkedId?: string;
  options?: any;
  optionArr?: any
  viewConfigType?: number;
  cardId?: string | null;
  cardName?: string| null;
  componentId?: string | null;
  description?: string;
  propertyNameEntityRef?: string;
  disableDelete?: boolean;
  systemColumnName?: string;
}

export interface EntityPropertyDisplayConfig {
  id?: string
  propertyName: string;
  entityPropertyId: string;
  entityNameRef: string;
  isMemberProperty?: boolean;
  isFixedPerson?: boolean;
  entityReferencePropertyId: string;
  type: number;
  option: { key: string; value: string }[];
  optionArr: { key: string; value: string }[];
  options?: any;
  name?: string;
}

export interface EntityListConfig {
  configurations: EntityPropertyDisplayConfiguration[];
}

export interface QueryEntityProperty {
  isIncludePropertyEntityReference?: boolean,
  isIncludePropertyOfList?: boolean,
  isUseFilter?: boolean,
  screenId?: string
}

export interface EntityPropertyDisplayResponse {
  propertyOfParticipants: EntityPropertyDisplayConfig[];
}

export interface EntityPropertyConfigs {
  properties: EntityPropertyDisplayConfig[];
  fixPersonProperties: EntityPropertyDisplayConfig[];
}

export interface EntityListViewConfigurations {
  configurations: EntityPropertyDisplayConfiguration[]
}

export interface EntitySectionConfig {
  title: string;
  columnName?: string;
  propertyName?: string;
}
export interface QueryEntityProperty {
  includeConfig?: boolean
}
